// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/entity/geo.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_proto_model_core_latlng } from "../core/latlng_pb";

/**
 * Describes the file proto/model/entity/geo.proto.
 */
export const file_proto_model_entity_geo = /*@__PURE__*/
  fileDesc("Chxwcm90by9tb2RlbC9lbnRpdHkvZ2VvLnByb3RvEgZjYXJtZW4iOAoIVmlld3BvcnQSHgoGY2VudGVyGAEgASgLMg4uY2FybWVuLkxhdExuZxIMCgR6b29tGAIgASgBIkcKDkNpcmN1bGFyUmVnaW9uEh4KBmNlbnRlchgBIAEoCzIOLmNhcm1lbi5MYXRMbmcSFQoNcmFkaXVzX21ldGVycxgCIAEoASJZChFSZWN0YW5ndWxhclJlZ2lvbhIhCglub3J0aGVhc3QYASABKAsyDi5jYXJtZW4uTGF0TG5nEiEKCXNvdXRod2VzdBgCIAEoCzIOLmNhcm1lbi5MYXRMbmcicAoGUmVnaW9uEioKCGNpcmN1bGFyGAEgASgLMhYuY2FybWVuLkNpcmN1bGFyUmVnaW9uSAASMAoLcmVjdGFuZ3VsYXIYAiABKAsyGS5jYXJtZW4uUmVjdGFuZ3VsYXJSZWdpb25IAEIICgZyZWdpb25CKFomZ2l0aHViLmNvbS95dW5hY2FiYS9jYXJtZW4vcHJvdG8vbW9kZWxiBnByb3RvMw", [file_proto_model_core_latlng]);

/**
 * Describes the message carmen.Viewport.
 * Use `create(ViewportSchema)` to create a new message.
 */
export const ViewportSchema = /*@__PURE__*/
  messageDesc(file_proto_model_entity_geo, 0);

/**
 * Describes the message carmen.CircularRegion.
 * Use `create(CircularRegionSchema)` to create a new message.
 */
export const CircularRegionSchema = /*@__PURE__*/
  messageDesc(file_proto_model_entity_geo, 1);

/**
 * Describes the message carmen.RectangularRegion.
 * Use `create(RectangularRegionSchema)` to create a new message.
 */
export const RectangularRegionSchema = /*@__PURE__*/
  messageDesc(file_proto_model_entity_geo, 2);

/**
 * Describes the message carmen.Region.
 * Use `create(RegionSchema)` to create a new message.
 */
export const RegionSchema = /*@__PURE__*/
  messageDesc(file_proto_model_entity_geo, 3);

